import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-32 pb-24 overflow-hidden bg-white" data-id="element-166">
      <div className="container mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-16 items-center" data-id="element-167">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-xl z-10" data-id="element-168">
          <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl font-semibold leading-tight tracking-tight text-ink mb-6" data-id="element-169">
            Бездоганний стиль, <br data-id="element-170" />
            що підкреслює вашу красу
          </h1>
          <p className="text-muted text-lg md:text-xl mb-10 font-normal leading-relaxed" data-id="element-171">
            Повний спектр послуг: від стрижок та складного фарбування до
            манікюру та догляду.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-16" data-id="element-172">
            <a href="#contact" className="px-8 py-4 bg-ink text-white text-center text-sm font-medium tracking-wide rounded-full hover:bg-black transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-173">
              Записатися на послугу
            </a>
            <a href="#courses" className="px-8 py-4 border border-line text-ink text-center text-sm font-medium tracking-wide rounded-full hover:bg-surface transition-all duration-300" data-id="element-174">
              Дізнатися про курси
            </a>
          </div>

          <div className="grid grid-cols-3 gap-6 border-t border-line pt-8" data-id="element-175">
            <div data-id="element-176">
              <p className="font-heading text-4xl font-semibold text-ink mb-1" data-id="element-177">
                12+
              </p>
              <p className="text-xs text-muted uppercase tracking-wider font-medium" data-id="element-178">
                Років досвіду
              </p>
            </div>
            <div data-id="element-179">
              <p className="font-heading text-4xl font-semibold text-ink mb-1" data-id="element-180">
                5k+
              </p>
              <p className="text-xs text-muted uppercase tracking-wider font-medium" data-id="element-181">
                Задоволених клієнтів
              </p>
            </div>
            <div data-id="element-182">
              <p className="font-heading text-4xl font-semibold text-ink mb-1" data-id="element-183">
                300+
              </p>
              <p className="text-xs text-muted uppercase tracking-wider font-medium" data-id="element-184">
                Випускників курсів
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative h-[600px] md:h-[800px] w-full group" data-id="element-185">
          <div className="absolute inset-0 bg-surface rounded-[2.5rem] overflow-hidden flex items-center justify-center border border-line shadow-2xl transition-transform duration-700 ease-out group-hover:scale-[1.02]" data-id="element-186">
            <div className="text-center" data-id="element-187">
              <div className="w-16 h-16 mx-auto mb-4 border border-line rounded-full flex items-center justify-center bg-white shadow-sm" data-id="element-188">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-muted" data-id="element-189">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2" data-id="element-190"></rect>
                  <circle cx="8.5" cy="8.5" r="1.5" data-id="element-191"></circle>
                  <polyline points="21 15 16 10 5 21" data-id="element-192"></polyline>
                </svg>
              </div>
              <p className="text-sm text-muted font-medium tracking-widest uppercase" data-id="element-193">
                Місце для фото
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}